import React from "react";
import { Fragment } from "react";
import { Image, Input, Button } from "antd";
import { RiSendPlane2Fill } from "react-icons/ri";
import PostVideoCard from "../Media/PostVideoCard";
import MediaUploader from "../../MediaUploader";
import { KEYS } from "../../../Config/Keys";
import { fallbackprofile } from "../../Utils";
import Loader from "../Loader";
import FadeInImage from "../../../common/Images/FadeInImage";
import useVariables from "../../hooks/useVariables";

function UploadPostcard({
  onPost,
  text,
  setText,
  uploadingMedia,
  setuploadingMedia,
  IMAGE,
  setimage,
  VIDEO,
  setvideo,
  loading,
  border,
  edit,
  setLuploading,
  Luploading,
  setIsFileRemoved
}) {
  //     uploadingMedia,
  //     setuploadingMedia,
  const { viewer } = useVariables();
  return (
    <Fragment>
      <div
        className={`toinputdiv ${border && "noPaddMargin"} ${edit}`}
        style={{
          borderColor: Luploading ? "transparent" : undefined,
          transition: "all .2s ease",
          borderBottom: "0px",
          padding: "14px"
        }}>
        <FadeInImage
          type="s40"
          fallaback={fallbackprofile}
          src={KEYS.API + "/" + viewer?.profile}
        />
        <Input.TextArea
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="totextarea mdTextarea"
          rows="1"
          placeholder="What's on your mind?"
        />
      </div>
      {Luploading ? (
        <div className="toinputpics uploaddedMediaTimeline">
          <Loader small noShadow PB />
        </div>
      ) : null}
      {(uploadingMedia === "image" || uploadingMedia === "video") && (
        <div
          className={`toinputpics `}
          style={{ opacity: Luploading ? 0 : 1, height: Luploading ? 0 : "auto" }}>
          <Fragment>
            {uploadingMedia === "image" && IMAGE.length > 0 && (
              <div className={`uploaddedMedia-grid files-${IMAGE.length}`}>
                {IMAGE.map((image, index) => (
                  <div
                    key={index}
                    className={`uploaddedMedia-item files-${IMAGE.length}-${index + 1}`}>
                    <Image
                      key={index}
                      fallback={fallbackprofile}
                      wrapperClassName="mask uploaddedMedia-img"
                      style={{ objectFit: "contain", display: "flex" }}
                      wrapperStyle={{ width: "100%", borderRadius: "20px" }}
                      src={image.preview}
                      alt={`image-${index}`}
                    />
                  </div>
                ))}
              </div>
            )}
            {uploadingMedia === "video" && VIDEO.length > 0 && (
              <div className={`uploaddedMedia-grid files-${VIDEO.length}`}>
                {VIDEO.map((video, index) => (
                  <div
                    key={index}
                    className={`uploaddedMedia-item files-${VIDEO.length}-${index + 1}`}>
                    <PostVideoCard
                      src={video.preview}
                      className={`uploaddedMedia-video`}
                      nodefault
                    />
                  </div>
                ))}
              </div>
            )}
          </Fragment>
        </div>
      )}

      <div
        className={`toinputpics ${border && "noPaddnoBorder"}`}
        style={{ borderTop: "0px", padding: "14px" }}>
        <div>
          <MediaUploader
            setIsFileRemoved={setIsFileRemoved}
            setmedia={setimage}
            media={IMAGE}
            mediaType="image"
            setuploadingMedia={setuploadingMedia}
            setLuploading={setLuploading}
            border={border}>
            <img alt="img" height="20px" width="20px" src="/images/photo.svg" />
            <span className="TimelineUploadMediaButtons">Photo</span>
          </MediaUploader>
          <MediaUploader
            setIsFileRemoved={setIsFileRemoved}
            setmedia={setvideo}
            media={VIDEO}
            mediaType="video"
            setuploadingMedia={setuploadingMedia}
            setLuploading={setLuploading}
            border={border}>
            <img alt="img" height="20px" width="20px" src="/images/video.svg" />
            <span className="TimelineUploadMediaButtons">Video</span>
          </MediaUploader>
          {(uploadingMedia === "image" || uploadingMedia === "video" || Luploading) && !loading ? (
            <img
              alt="img"
              height="23px"
              style={{
                marginLeft: "11px",
                cursor: "pointer",
                zIndex: "12"
              }}
              onClick={() => {
                if (setIsFileRemoved) {
                  setIsFileRemoved(true);
                }
                setuploadingMedia("error");
              }}
              width="23px"
              src="/images/undo.png"
            />
          ) : null}
        </div>
        <Button
          className="Button PostButton"
          style={{
            marginLeft: "auto",
            display: "flex",
            alignItems: "center",
            gap: ".2rem",
            justifyContent: border ? "center" : "unset",
            minWidth: border ? "unset" : "initial",
            background: "linear-gradient(270.95deg, #5CB1FF 0%, #0084FF 100%)"
          }}
          loading={loading || Luploading}
          icon={<RiSendPlane2Fill fontSize={".86rem"} />}
          type="primary"
          shape="round"
          onClick={() => onPost()}>
          <span style={{ marginLeft: "10px", fontWeight: "400" }}>Post</span>
        </Button>
      </div>

      <hr
        style={{
          color: "#A8A8A8",
          backgroundColor: "#A8A8A8",
          height: 0.5,
          border: "none",
          width: "100%",
          marginBottom: "3%"
        }}
      />
    </Fragment>
  );
}

export default UploadPostcard;
